import { render, staticRenderFns } from "./GalleryFrame.vue?vue&type=template&id=892364ae&scoped=true&"
import script from "./GalleryFrame.vue?vue&type=script&lang=js&"
export * from "./GalleryFrame.vue?vue&type=script&lang=js&"
import style0 from "./GalleryFrame.vue?vue&type=style&index=0&id=892364ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892364ae",
  null
  
)

export default component.exports